import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesPeopleInactiveRoute extends Route {
  @service store;

  model() {
    return this.modelFor('resources').people.inactive;
  }
}

export default instrumentRoutePerformance(ResourcesPeopleInactiveRoute);
